import {IVideoResolution} from "../video-player.view-model.interface";
import {TimeSpan} from "@sparkware/app-utils";

export interface IVideoAnalyticsReporter {

    reportPlayStarted(): void;
    reportRetryPlaySuccess(): void;
    reportResumePlaySuccess(): void;
    reportPreloadError(error: any): void;
    reportPauseOnAppSleep(): void;
    reportPlayError(error: any): void;
    reportRetryPlayError(error: any): void;
    reportResumePlayError(error: any): void;
    reportDroppedFrames(droppedVideoFrames: number): void;
    reportWatchTimeLimitReached(): void;
    reportPosterLoadFailure(error: any): void;
    reportVideoResolutionChanged(previousResolution: IVideoResolution, currentResolution: IVideoResolution): void;
    reportBufferingTime(bufferingTime: TimeSpan): void;
    reportMute(): void;
    reportUnmute(): void;
}

export function isVideoFatalError(error: any): boolean {
    if(!error) {
        return false;
    }

    switch (error.name) {
        case 'NotAllowedError':
            //If we get NotAllowedError it means that we can't autoplay the video. but it doesn't mean is a fatal error. The user can still play the video by click on play button
            return false;
        case 'AbortError':
            return !(error.message && error.message.indexOf('The play() request was interrupted') >= 0); //usually these are not fatal errors.

        default:
            return true;
    }
}